import { theme } from '../../core/design-system/theme'

const baseStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '5px 10px',
  borderRadius: '99px',
  fontFamily: theme.fonts.body,
  fontSize: '11px',
  fontWeight: 700,
  background: theme.colors.sageLight,
  color: theme.colors.successText,
}

/**
 * TrustBadge — small sage pill for trust / credential labels.
 * @param {object} props
 * @param {string} props.label
 * @param {boolean} [props.withIcon] — show a check SVG before the label
 */
export function TrustBadge({ label, withIcon = false }) {
  return (
    <span style={baseStyle}>
      {withIcon && (
        <svg
          viewBox="0 0 16 16"
          width="11"
          height="11"
          aria-hidden="true"
          fill="none"
          stroke={theme.colors.successText}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="2 8 6 12 14 4" />
        </svg>
      )}
      {label}
    </span>
  )
}
